<div class="wrapper">
  <div class="blog" *ngIf="page">
    <h1>{{page.titre}}</h1>
    <p [innerHTML]="page.description"></p>
    <div *ngFor="let paragraphe of page.paragraphes">
      <h2>{{paragraphe.titre}}</h2>
      <div [innerHTML]="paragraphe.description"></div>
    </div>
  </div>
  <div class="blog" *ngIf="!page">
    <span>Cette page n'existe pas veuillez vous échapper vers d'autre destination sur notre site !</span>
  </div>
</div>